import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromSelectedMinorTransferState from '../../reducers/minor-transfer/minor-transfer.reducer';

export const selectMinorTransferState = createSelector(
  fromFeature.getMinorTransferState,
  (state) => state,
);

export const selectMinorTransferAccountFrom = createSelector(
  selectMinorTransferState,
  fromSelectedMinorTransferState.getMinorTransferFrom,
);

export const selectMinorTransferAccountTo = createSelector(
  selectMinorTransferState,
  fromSelectedMinorTransferState.getMinorTransferTo,
);

export const selectMinorTransferTotalTransferValue = createSelector(
  selectMinorTransferState,
  fromSelectedMinorTransferState.getMinorTransferTotalTransferValue,
);
